import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home'
import Honor from '@/components/Honor'
import Index from '@/components/Index'

import News from '@/components/News/News'
import NewsDetail from '@/components/News/NewsDetail'

import AboutUs from '@/components/AboutUs/AboutUs'

import CallUs from '@/components/CallUs'
import FoodCase from '@/components/FoodCase'
import SafeCase from '@/components/SafeCase'
import CaseDetail from '@/components/CaseDetail'
import SafeCaseDetail from '@/components/SafeCaseDetail'
import CompanyProfile from '@/components/AboutUs/CompanyProfile'
import Serving from '@/components/AboutUs/Serving'
import Managerment from '@/components/AboutUs/Managerment'
import Operation from '@/components/AboutUs/Operation'

import Food from '@/components/Business/Food'
import Safe from '@/components/Business/Safe'
import Service from '@/components/Business/Service'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
  {
    path: '/',
    name: '宏邦保安',
    component: Index,
    children: [{
      path: '/',
      component: Home,
      name: '宏邦保安'
    },

    { path: '/News/News', component: News, name: '宏邦保安' },
    {
      path: '/News/NewsDetail/:id',
      component: NewsDetail,
      name: ''
    },

    {
      path: '/AboutUs',
      component: AboutUs,
      name: '宏邦保安',
      children: [{
        path: '/AboutUs/CompanyProfile',
        component: CompanyProfile,
        name: '公司介绍'
      },
      {
        path: '/AboutUs/Managerment',
        component: Managerment,
        name: '六大管理体系'
      },
      {
        path: '/AboutUs/Operation',
        component: Operation,
        name: '六大操作流程'
      },
      {
        path: '/AboutUs/Serving',
        component: Serving,
        name: '四大供餐模式'
      },
        // {
        //   path: '/News/News',
        //   component: News,
        //   name: '新闻动态'
        // },

      ]
    },
    {
      path: '/Honor',
      component: Honor,
      name: '宏邦保安'
    },
    {
      path: '/Food',
      component: Food,
      name: '宏邦保安'
    },
    {
      path: '/Safe',
      component: Safe,
      name: '宏邦保安'
    },
    {
      path: '/Service',
      component: Service,
      name: '宏邦保安'
    },
    {
      path: '/CallUs',
      component: CallUs,
      name: '宏邦保安'
    },

    {
      path: '/FoodCase',
      component: FoodCase,
      name: '宏邦保安'
    },
    {
      path: '/SafeCase',
      component: SafeCase,
      name: '宏邦保安'
    },
    {
      path: '/Case/:id',
      component: CaseDetail,
      name: ''
    },
    {
      path: '/SafeCase/:id',
      component: SafeCaseDetail,
      name: ''
    },
    ]
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
